import { useMemo } from "react";

import type { VoucherForCampaign_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useInitMarketingCampaignFormModelContext } from "../../../init";
import { serverModelToInputModelConverter } from "./converter/server-model-to-input-model/server-model-to-input-model";
import { useCampaignEditMutation } from "../../../repository/existing";
import { useExistingCampaignPublish } from "../../../repository/existing/mutation/use-campaign-publish-mutation";

import type { MarketingExistingCampaignFormModelContextType } from "../../../../ui/existing/context/context";
import type { MarketingCampaignFormModel } from "../../../type";

type Props = {
	serverModel: VoucherForCampaign_EditPageQuery;
};

export const useInitialized = ({ serverModel }: Props): MarketingExistingCampaignFormModelContextType => {
	const inputModel = useMemo(() => serverModelToInputModelConverter(serverModel), [serverModel]);

	const queryData = {
		hotelEmailAddress: serverModel.hotel.email ?? "",
	} satisfies MarketingCampaignFormModel["QueryData"];

	const { onSetViewModel, onResetViewModel, viewModel } = useInitMarketingCampaignFormModelContext({
		inputModel,
		queryData,
	});

	const { onUpdate } = useCampaignEditMutation({ onResetViewModel });
	const { onPublish } = useExistingCampaignPublish({ onResetViewModel });

	return {
		queryData,
		onSetViewModel,
		viewModel,
		onUpdate: () => onUpdate({ ...viewModel }),
		onPublish: () => onPublish(viewModel),
	};
};
